import React from "react";

import {
  CLOSED_TOOLBOX_SIZE_OPTIONS,
  CLOSED_TOOLBOX_TYPE_OPTIONS,
} from "../../../data";
import { FieldsRow, StructureCard } from "../OpenBoxQuotes/BoxStructureFields";
import { NumberField, SelectField } from "../OpenBoxQuotes/FormFields";
import { useClosedBoxAccessories } from "./AccessoriesCards";
import { closedKey } from "./BoxStructureCards";

export const ToolboxCard = () => {
  const { data, patch } = useClosedBoxAccessories();
  const item = data.toolbox;

  return (
    <StructureCard
      enabled={item.enabled}
      titleKey={closedKey("CARDS.TOOLBOX")}
      onToggle={(enabled) => patch("toolbox", { enabled })}
    >
      <FieldsRow>
        <SelectField
          labelKey={closedKey("FIELDS.TYPE")}
          value={item.selectedOption}
          options={CLOSED_TOOLBOX_TYPE_OPTIONS}
          onChange={(selectedOption) => patch("toolbox", { selectedOption })}
          grow
        />
        <SelectField
          labelKey={closedKey("FIELDS.SIZE")}
          value={item.size}
          options={CLOSED_TOOLBOX_SIZE_OPTIONS}
          onChange={(size) => patch("toolbox", { size })}
          grow
        />
        <NumberField
          labelKey={closedKey("FIELDS.QUANTITY")}
          value={item.quantity}
          onChange={(quantity) => patch("toolbox", { quantity })}
          shortStepper
        />
      </FieldsRow>
    </StructureCard>
  );
};

export const OpenBasketCard = () => {
  const { data, patch } = useClosedBoxAccessories();
  const item = data.openBasket;

  return (
    <StructureCard
      enabled={item.enabled}
      titleKey={closedKey("CARDS.OPEN_BASKET")}
      onToggle={(enabled) => patch("openBasket", { enabled })}
    >
      <FieldsRow>
        <NumberField
          labelKey={closedKey("FIELDS.LENGTH_MM")}
          value={item.length}
          onChange={(length) => patch("openBasket", { length })}
          grow
        />
        <NumberField
          labelKey={closedKey("FIELDS.WIDTH_MM")}
          value={item.width}
          onChange={(width) => patch("openBasket", { width })}
          grow
        />
        <NumberField
          labelKey={closedKey("FIELDS.HEIGHT_MM")}
          value={item.height}
          onChange={(height) => patch("openBasket", { height })}
          grow
        />
        <NumberField
          labelKey={closedKey("FIELDS.QUANTITY")}
          value={item.quantity}
          onChange={(quantity) => patch("openBasket", { quantity })}
          grow
        />
      </FieldsRow>
    </StructureCard>
  );
};
